import { Toast as ToastProps } from 'react-hot-toast';
import { Bike, ShoppingBag } from 'lucide-react';
import { ORDER_METHODS } from '../services/exports/Constants';

interface Props {
  t: ToastProps;
  channel: ORDER_METHODS.PICKUP | ORDER_METHODS.DELIVERY;
  countLabel: string;
  reasonLabel: string;
}

export default function ChannelDropToast(props: Props) {
  const { t, channel, countLabel, reasonLabel } = props;
  const Icon = channel === ORDER_METHODS.PICKUP ? ShoppingBag : Bike;

  return (
    <div className={container} style={{ opacity: t.visible ? 1 : 0 }}>
      <div className={iconBadge}>
        <Icon size={12} strokeWidth={2.2} />
      </div>
      <span className={text}>
        <strong className={countText}>{countLabel}</strong>
        <span className={reasonText}>{reasonLabel}</span>
      </span>
    </div>
  );
}

const container =
  'flex items-center gap-2.5 rounded-lg px-3.5 py-3 bg-[#0F172A] text-white shadow-[0_8px_24px_rgba(15,23,42,0.18)] transition-opacity duration-200 max-w-[427px] w-[calc(100vw-32px)]';
const iconBadge =
  'flex items-center justify-center w-[22px] h-[22px] rounded shrink-0 bg-[rgba(245,176,80,0.25)] text-[#F5B050]';
const text = 'text-[13px] leading-[18.2px]';
const countText = 'font-semibold';
const reasonText = 'font-medium text-white/75 ml-1';
